import Macy from "macy";
import AOS from "aos";

export default function initMasonry() {
  document.querySelectorAll(".masonry").forEach((masonryContainer) => {
    const macyInstance = Macy({
      container: masonryContainer,
      columns: 4,
      margin: 24,
      breakAt: {
        1200: 4,
        940: 3,
        768: 2,
        500: 1,
      },
    });

    // Wait for Macy.js to complete layout changes
    setTimeout(() => {
      AOS.refresh();
    }, 500); // Small delay to ensure elements are placed correctly
  });
}
